const PermissionPage = () => {
    const categories = [
        "Sales", "Orders", "Stock", "Purchases", "Production", 
        "Return", "Accounts", "Data and Clerical", "Human Resource", "Master Setup"
    ];

    return (
        <div className="row">
            <div className="col-12">
                <div className="card p-3">
                    <ul className="list-unstyled d-flex flex-wrap gap-2">
                        {categories.map((category, index) => (
                            <li key={index} className="badge bg-success text-white px-3 py-2">
                                <h5 className="text-white">{category}</h5>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default PermissionPage;
